module.exports = __webpack_public_path__ + "img/pic20.c7ad0abb.png";